import React from 'react'
import classNames from 'classnames'
import classes from './Button.module.css'
import { Link } from 'react-router-dom'

export const ButtonVariants = Object.freeze({
    primary: 'primary',
    secondary: 'secondary',
    secondaryOutline: 'secondaryOutline',
})

export const ButtonIcon = ({ icon, className, ...props }) => (
    <span
        className={classNames(classes.buttonIcon, className)}
        aria-hidden="true"
        {...props}
    >
        {icon}
    </span>
)

export const Button = ({
    className,
    to = null,
    type = 'button',
    onClick = null,
    label = null,
    iconOnly = false,
    block = false,
    variant = ButtonVariants.primary,
    uppercase = false,
    children,
    bold = false,
    smallRadius = false,
    ...props
}) => {
    if (iconOnly && !label)
        throw new Error('You must provide a label for iconOnly buttons')
    const buttonClasses = classNames(
        classes.button,
        smallRadius && classes.buttonSmallRadius,
        bold && classes.buttonBold,
        iconOnly && classes.iconOnly,
        block && classes.block,
        variant === ButtonVariants.secondary && classes.secondaryButton,
        variant === ButtonVariants.secondaryOutline &&
            classes.secondaryButtonOutline,
        uppercase && classes.uppercase,
        className
    )
    if (to) {
        return (
            <Link
                to={to}
                className={buttonClasses}
                onClick={onClick}
                {...(iconOnly && {
                    'aria-label': label,
                })}
                {...props}
            >
                {children}
            </Link>
        )
    } else {
        return (
            <button
                className={buttonClasses}
                type={type}
                onClick={onClick}
                {...(iconOnly && {
                    'aria-label': label,
                })}
                {...props}
            >
                {children}
            </button>
        )
    }
}
